import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lp-sip',
  templateUrl: './lp-sip.component.html',
  styleUrls: ['./lp-sip.component.css']
})
export class LpSipComponent implements OnInit, OnDestroy {

  private gtmScriptEl: HTMLScriptElement | null = null;
  private gtmConfigEl: HTMLScriptElement | null = null;
  private gtmScript2El: HTMLScriptElement | null = null;
  private gtmNoscriptEl: HTMLElement | null = null;

  meta_title: string = '';
  meta_desc: string = '';
  meta_keywords: string = '';

  name: string = "";
  mobile: string = "";
  sipVal: string = "";
  nameValidateMessage: any = '';
  mobileValidateMessage: string = '';
  sipValValidateMessage: string = '';
  cityModel = '';
  cityMesaage: any = '';
  cityList: [] = [];
  cityName: string = "Select your city?";
  cityId: number = 0;

  userOTP: string = "";
  isTimer: boolean = true;
  isResend: boolean = false;
  otpError: boolean = false;
  otpVerified: boolean = false;
  isOtpVisible: boolean = false;
  otpValidateMessage: string = '';
  isThanksVisible: boolean = false;

  intervalId: any;
  timeleft: number = 0;
  redirectToPage: string = "";
  clickedResend: number = 0;
  resendBtnTimer = 3;


  name2: string = "";
  mobile2: string = "";
  sipVal2: string = "";
  nameValidateMessage2: any = '';
  mobileValidateMessage2: string = '';
  sipValValidateMessage2: string = '';
  cityModel2 = '';
  cityMesaage2: any = '';
  cityList2: [] = [];
  cityName2: string = "Select your city?";
  cityId2: number = 0;

  userOTP2: string = "";
  isTimer2: boolean = true;
  isResend2: boolean = false;
  otpError2: boolean = false;
  otpVerified2: boolean = false;
  isOtpVisible2: boolean = false;
  otpValidateMessage2: string = '';
  isThanksVisible2: boolean = false;

  intervalId2: any;
  timeleft2: number = 0;
  redirectToPage2: string = "";
  clickedResend2: number = 0;
  resendBtnTimer2 = 3;

  sip: number = 10000;
  years: number = 20;
  rate: number = 12;
  stepUp: boolean = false;

  invested: number = 0;
  corpus: number = 0;
  showResult: boolean = false;

  visitorId: any;
  leadId: string = '';
  leadId2: string = '';
  visitortype: string = '';

  constructor(private service: DataService, private titleService: Title, private metaService: Meta, private router: Router, @Inject(DOCUMENT) private document: Document) { }


  ngOnInit(): void {
    this.service.cityDropDown().subscribe((data: any) => {
      this.cityList = data['data'];
    })
    if (sessionStorage.getItem('visitorId')) {
      this.visitorId = '';
      sessionStorage.setItem('visitorId', '');
    }
    if (sessionStorage.getItem('leadId')) {
      this.leadId = '';
      sessionStorage.removeItem('leadId')
    }
    if (sessionStorage.getItem('leadId2')) {
      this.leadId2 = '';
      sessionStorage.removeItem('leadId2')
    }
    this.createVisitor();
    this.metaForSEO('lp-sip');
    this.injectGtag();
    this.injectGtmContainer();
  }

  ngOnDestroy(): void {
    if (this.gtmScriptEl) {
      this.document.head.removeChild(this.gtmScriptEl);
    }
    if (this.gtmConfigEl) {
      this.document.head.removeChild(this.gtmConfigEl);
    }
    if (this.gtmScript2El) {
      this.document.head.removeChild(this.gtmScript2El);
    }
    if (this.gtmNoscriptEl) {
      this.document.body.removeChild(this.gtmNoscriptEl);
    }
  }

  private injectGtag(): void {
    this.gtmScriptEl = this.document.createElement('script');
    this.gtmScriptEl.async = true;
    this.gtmScriptEl.src = 'https://www.googletagmanager.com/gtag/js?id=AW-18261612633';
    this.document.head.appendChild(this.gtmScriptEl);

    this.gtmConfigEl = this.document.createElement('script');
    this.gtmConfigEl.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-18261612633');
    `;
    this.document.head.appendChild(this.gtmConfigEl);
  }

  private injectGtmContainer(): void {
    this.gtmScript2El = this.document.createElement('script');
    this.gtmScript2El.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PSPS8S7B');
    `;
    this.document.head.appendChild(this.gtmScript2El);

    this.gtmNoscriptEl = this.document.createElement('noscript');
    const iframe = this.document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-PSPS8S7B';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    this.gtmNoscriptEl.appendChild(iframe);
    if (this.document.body.firstChild) {
      this.document.body.insertBefore(this.gtmNoscriptEl, this.document.body.firstChild);
    } else {
      this.document.body.appendChild(this.gtmNoscriptEl);
    }
  }

  GetParameterValues(param: string) {
    var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < url.length; i++) {
      var urlparam = url[i].split('=');
      if (urlparam[0] == param) {
        return urlparam[1];
      }
    }
    return
  }

  metaForSEO(slugname: string): void {
    this.service.getDynamicMeta().subscribe(
      (data: any) => {
        const seoPages = data?.rows?.[0]?.seo_pages || [];

        seoPages.forEach((v: any) => {
          if (v.seo_slug === slugname || v.seo_slug === "/" + slugname) {
            this.meta_title = v.seo_title;
            this.meta_desc = v.seo_description;
            this.meta_keywords = v.seo_keywords;

            this.titleService.setTitle(this.meta_title);
            this.metaService.removeTag('name="keywords"');
            this.metaService.removeTag('name="description"');
            this.metaService.addTags([
              { name: 'keywords', content: this.meta_keywords },
              { name: 'description', content: this.meta_desc },
              { name: 'robots', content: 'index, follow' }
            ]);
          }
        });
      },
      (err) => {
        console.error('Error fetching SEO metadata:', err);
      }
    );
  }

  createVisitor() {
    let jscd = window['jscd'];
    if (!sessionStorage.getItem('visitorId')) {
      let obj = {
        "browsername": jscd?.browser,
        "browserversion": jscd?.browser + ' ' + jscd?.browserVersion,
        "operatingsystem": jscd?.os + " " + jscd?.osVersion,
        "device": jscd?.os,
        "sourceurl": window.location.href,
        "productid": '60',
        "visitortype": "campaign-lpsip",
        "utmsource": this.GetParameterValues("utm_source"),
        "utmmedium": this.GetParameterValues("utm_medium"),
        "leadsource": this.GetParameterValues("lead_source"),
        "utmcampaign": this.GetParameterValues("utm_campaign"),
      };
      this.visitortype = "campaign-lpsip"; // VISITOR TYPE
      this.service.createVisitor(obj).subscribe((data: any) => {
        this.visitorId = data["visitorId"];
        sessionStorage.setItem('visitorId', data["visitorId"])
      },
        err => {
          console.log(err);
          throw err;
        })
    } else {
      this.visitorId = sessionStorage.getItem('visitorId')
    }
  }


  async PostData() {
    let val = await this.checkValidationMsg();
    if (val) {
      if (this.isOtpVisible == true) {
        if (this.otpVerified) {
          this.pushLeadLSQ();
          // Navigate to the reusable thank-you page
          this.router.navigate(['/thankyou'], { state: { source: 'sip' } });
        } else {
          this.SubmitOTP();
        }
      } else {
        this.createLead();
        this.isOtpVisible = true;
      }
    }
  }

  checkValidationMsg() {
    let num: number = 0;
    if (this.name && this.name.length < 3) {
      this.nameValidateMessage = "lengthError";
      num += 1;
    }
    if (!this.name) {
      this.nameValidateMessage = "required";
      num += 1;
    }
    if (this.isMobileWrong(this.mobile) == 0) {
      this.mobileValidateMessage = "invalid";
      num += 1;
    }
    if (!this.mobile) {
      this.mobileValidateMessage = "required";
      num += 1;
    }
    if (this.mobile && this.mobile.length != 10) {
      this.mobileValidateMessage = "lengthError";
      num += 1;
    }
    if (!this.sipVal) {
      this.sipValValidateMessage = "required";
      num += 1;
    }
    if (!this.cityModel) {
      this.cityMesaage = "required";
      num += 1;
    }
    if (num > 0) {
      return false;
    } else {
      return true;
    }
  }

  createLead() {
    let leadid = sessionStorage.getItem('leadId');
    this.visitorId = sessionStorage.getItem('visitorId')
    let obj = {
      "visitorid": this.visitorId,
      "leadid": leadid ? leadid : 0,
      "name": this.name,
      "mobile": this.mobile,
    }
    this.service.createLead(obj).subscribe((data: any) => {
      sessionStorage.setItem('leadId', data['leadid'])
      this.leadId = data['leadid'];
      this.sendOtp();
      this.startTimer();
      if (!data['success']) {
      }
    }, err => {
      console.log(err);
    })
  }

  SubmitOTP() {
    if (this.userOTP && this.userOTP.length<6) {
      this.otpValidateMessage = "lengthError";
      this.otpError = false;
    } else if (this.userOTP && this.userOTP.length==6) {
      this.otpValidateMessage = "";
    } else {
      this.otpValidateMessage = "required";
      this.otpError = false;
    }
  }

  sendOtp() {
    this.service.sendOtp({ leadid: this.leadId, mobile: this.mobile }).subscribe(data => {
    }, err => {
      console.log(err);
    })
  }

  checkOtpLength() {
    if (this.userOTP && this.userOTP.length === 6) {
      this.VerifyOTP();
    } else {
      this.otpValidateMessage = '';
    }
  }

  VerifyOTP() {
    this.service.verifyOtp({ leadid: this.leadId, otp: this.userOTP }).subscribe(data => {
      if (data["success"]) {
        this.otpError = false;
        this.otpVerified = true;
        this.isTimer = false;
        this.isResend = false;
        this.otpValidateMessage = '';

      } else {
        this.otpError = true;
      }
    }, err => {
      console.log(err);
    })
  }

  pushLeadLSQ(){
    let utm_source = this.GetParameterValues("utm_source");
    let utm_medium = this.GetParameterValues("utm_medium");
    let lead_source = this.GetParameterValues("lead_source");
    let utm_campaign = this.GetParameterValues("utm_campaign");

    let utm_term = this.GetParameterValues("utm_term");
    let utm_content = this.GetParameterValues("utm_content");

    this.service.pushLeadToLSQ(
      {
        visitor_type: this.visitortype,
        Name: this.name,
        Mobile: this.mobile,
        // Email: this.email,
        City: this.cityName,
        Remarks: this.sipVal,
        Campaign_Name: 'SIP-Digital-VIS-Team',
        Landing_Page_URL: window.location.href,
        LEADID: this.leadId,
        Product: "Mutual Funds",
        Sub_LeadSource: utm_source ? utm_source : 'Website',
        Utm_Source: utm_source ? utm_source : 'Websites',
        Utm_Medium: utm_medium ? utm_medium : '',
        Utm_Campaign: utm_campaign ? utm_campaign : '',
        Utm_Term: utm_term ? utm_term : '',
        Utm_Content: utm_content ? utm_content : '',
        LeadSource: 'Digital Marketing',
        Entity_Type: 'Digital_BCL',
      }
    ).subscribe((res: any) => {
      if (res["success"]) {
        let sfid = res['id'];
        if (sfid) {
          sessionStorage.setItem('LSQ_id', sfid);
          sessionStorage.setItem('mobile', this.mobile);
        }
        sessionStorage.removeItem('leadId')
        this.leadId = '';
      }
    });
  }

  startTimer() {
    clearInterval(this.intervalId);
    this.otpError = false;
    this.timeleft = 20;
    this.timeleft -= 1;
    this.intervalId = setInterval(() => {
      if (this.timeleft == 0 && this.isOtpVisible == true) {
        if (this.clickedResend === this.resendBtnTimer) {
          this.isResend = false;
        }
        if (this.clickedResend > 0 && this.clickedResend < this.resendBtnTimer) {
          this.isResend = true;
        }
        this.isTimer = false;
        clearInterval(this.intervalId);
        if (this.clickedResend == 0) {
          this.isResend = true;
        }
      }
      this.timeleft -= 1;
    }, 1000);
  }

  resendOTP() {
    this.userOTP = "";
    this.clickedResend++;
    this.sendOtp();
    this.startTimer();
    this.isTimer = true;
    this.isResend = false;
  }

  removeErrorMsg(fieldname: string) {
    if (fieldname == "name") {
      this.nameValidateMessage = "";
    }
    if (fieldname == "mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname == "city") {
      this.cityMesaage = "";
    }
    if (fieldname == "sipval") {
      this.sipValValidateMessage = "";
    }
    if (fieldname == "otp") {
      this.otpValidateMessage = "";
    }
  }

  async PostData2() {
    let val = await this.checkValidationMsg2();
    if (val) {
      if (this.isOtpVisible2 == true) {
        if (this.otpVerified2) {
          this.pushLeadLSQ2();
          // Navigate to the reusable thank-you page
          this.router.navigate(['/thankyou'], { state: { source: 'sip' } });
        } else {
          this.SubmitOTP2();
        }
      } else {
        this.createLead2();
        this.isOtpVisible2 = true;
      }
    }
  }

  checkValidationMsg2() {
    let num: number = 0;
    if (this.name2 && this.name2.length < 3) {
      this.nameValidateMessage2 = "lengthError";
      num += 1;
    }
    if (!this.name2) {
      this.nameValidateMessage2 = "required";
      num += 1;
    }
    if (this.isMobileWrong(this.mobile2) == 0) {
      this.mobileValidateMessage2 = "invalid";
      num += 1;
    }
    if (!this.mobile2) {
      this.mobileValidateMessage2 = "required";
      num += 1;
    }
    if (this.mobile2 && this.mobile2.length != 10) {
      this.mobileValidateMessage2 = "lengthError";
      num += 1;
    }
    if (!this.sipVal2) {
      this.sipValValidateMessage2 = "required";
      num += 1;
    }
    if (!this.cityModel2) {
      this.cityMesaage2 = "required";
      num += 1;
    }
    if (num > 0) {
      return false;
    } else {
      return true;
    }
  }

  createLead2() {
    let leadid2 = sessionStorage.getItem('leadId2');
    this.visitorId = sessionStorage.getItem('visitorId')
    let obj = {
      "visitorid": this.visitorId,
      "leadid": leadid2 ? leadid2 : 0,
      "name": this.name2,
      "mobile": this.mobile2,
    }
    this.service.createLead(obj).subscribe((data: any) => {
      sessionStorage.setItem('leadId2', data['leadid'])
      this.leadId2 = data['leadid'];
      this.sendOtp2();
      this.startTimer2();
      if (!data['success']) {
      }
    }, err => {
      console.log(err);
    })
  }

  SubmitOTP2() {
    if (this.userOTP2 && this.userOTP2.length<6) {
      this.otpValidateMessage2 = "lengthError";
      this.otpError2 = false;
    } else if (this.userOTP2 && this.userOTP2.length==6) {
      this.otpValidateMessage2 = "";
    } else {
      this.otpValidateMessage2 = "required";
      this.otpError2 = false;
    }
  }

  sendOtp2() {
    this.service.sendOtp({ leadid: this.leadId2, mobile: this.mobile2 }).subscribe(data => {
    }, err => {
      console.log(err);
    })
  }

  resendOTP2() {
    this.userOTP2 = "";
    this.clickedResend2++;
    this.sendOtp2();
    this.startTimer2();
    this.isTimer2 = true;
    this.isResend2 = false;
  }

  checkOtpLength2() {
    if (this.userOTP2 && this.userOTP2.length === 6) {
      this.VerifyOTP2();
    } else {
      this.otpValidateMessage2 = '';
    }
  }

  VerifyOTP2() {
    this.service.verifyOtp({ leadid: this.leadId2, otp: this.userOTP2 }).subscribe(data => {
      if (data["success"]) {
        this.otpError2 = false;
        this.otpVerified2 = true;
        this.isTimer2 = false;
        this.isResend2 = false;
        this.otpValidateMessage2 = '';

      } else {
        this.otpError2 = true;
      }
    }, err => {
      console.log(err);
    })
  }

  pushLeadLSQ2(){
    let utm_source = this.GetParameterValues("utm_source");
    let utm_medium = this.GetParameterValues("utm_medium");
    let lead_source = this.GetParameterValues("lead_source");
    let utm_campaign = this.GetParameterValues("utm_campaign");

    let utm_term = this.GetParameterValues("utm_term");
    let utm_content = this.GetParameterValues("utm_content");

    this.service.pushLeadToLSQ(
      {
        visitor_type: this.visitortype,
        Name: this.name2,
        Mobile: this.mobile2,
        // Email: this.email,
        City: this.cityName2,
        Campaign_Name: 'SIP-Digital-VIS-Team',
        Landing_Page_URL: window.location.href,
        LEADID: this.leadId2,
        Product: "Mutual Funds",
        Sub_LeadSource: utm_source ? utm_source : 'Website',
        Utm_Source: utm_source ? utm_source : 'Websites',
        Utm_Medium: utm_medium ? utm_medium : '',
        Utm_Campaign: utm_campaign ? utm_campaign : '',
        Utm_Term: utm_term ? utm_term : '',
        Utm_Content: utm_content ? utm_content : '',
        LeadSource: 'Digital Marketing',
        Entity_Type: 'Digital_BCL',
      }
    ).subscribe((res: any) => {
      if (res["success"]) {
        let sfid = res['id'];
        if (sfid) {
          sessionStorage.setItem('LSQ_id2', sfid);
          sessionStorage.setItem('mobile2', this.mobile2);
        }
        sessionStorage.removeItem('leadId2')
        this.leadId2 = '';
      }
    });
  }

  startTimer2() {
    clearInterval(this.intervalId2);
    this.otpError2 = false;
    this.timeleft2 = 20;
    this.timeleft2 -= 1;
    this.intervalId2 = setInterval(() => {
      if (this.timeleft2 == 0 && this.isOtpVisible2 == true) {
        if (this.clickedResend2 === this.resendBtnTimer2) {
          this.isResend2 = false;
        }
        if (this.clickedResend2 > 0 && this.clickedResend2 < this.resendBtnTimer2) {
          this.isResend2 = true;
        }
        this.isTimer2 = false;
        clearInterval(this.intervalId2);
        if (this.clickedResend2 == 0) {
          this.isResend2 = true;
        }
      }
      this.timeleft2 -= 1;
    }, 1000);
  }


  removeErrorMsg2(fieldname: string) {
    if (fieldname == "name2") {
      this.nameValidateMessage2 = "";
    }
    if (fieldname == "mobile2") {
      this.mobileValidateMessage2 = "";
    }
    if (fieldname == "city2") {
      this.cityMesaage2 = "";
    }
    if (fieldname == "sipval2") {
      this.sipValValidateMessage2 = "";
    }
    if (fieldname == "otp2") {
      this.otpValidateMessage2 = "";
    }
  }

  alphaOnly(event: any) {
    var key = event.keyCode;
    return ((key >= 65 && key <= 90) || (key == 8 || key == 32));
  };

  numbersOnly($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0' || $event.key === '1' || $event.key === '2' || $event.key === '3' || $event.key === '4' || $event.key === '5') {
        return false;
      }
    }
    var reg = /^[0-9]+$/;
    return (reg.test($event.key));
  };

  isMobileWrong(mobile: string) {
    let firstDigit = mobile.substring(0, 1);
    if (firstDigit != '6' && firstDigit != '7' && firstDigit != '8' && firstDigit != '9') {
      return 0;
    }
    else if (mobile.match(/^(\d)\1+$/g)) {
      return 0;
    }
    else {
      return 1;
    }
  }

  numberspincode($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0') {
        return false;
      }
    }
    var reg = /^[0-9]+$/;
    return (reg.test($event.key));
  };

  ValidateCity() {
    if (this.cityModel === '') {
      this.cityMesaage = 'required';

    } else {
      let values = this.cityModel.split("-");
      this.cityName = values[0];
      this.cityId = parseInt(values[1]);
      if (this.cityId)
        this.cityMesaage = 'validate';
    }

  }

  ValidateCity2() {
    if (this.cityModel2 === '') {
      this.cityMesaage2 = 'required';

    } else {
      let values = this.cityModel2.split("-");
      this.cityName2 = values[0];
      this.cityId2 = parseInt(values[1]);
      if (this.cityId2)
        this.cityMesaage2 = 'validate';
    }

  }

  calc() {
    const sip = +this.sip;
    const years = +this.years;
    const rate = (+this.rate) / 100;
    const step = this.stepUp;

    let invested = 0;
    let corpus = 0;

    if (!step) {
      invested = sip * 12 * years;
      const r = rate / 12;
      const n = years * 12;
      corpus = sip * ((Math.pow(1 + r, n) - 1) / r) * (1 + r);
    } else {
      let mSip = sip;
      const r = rate / 12;

      for (let y = 1; y <= years; y++) {
        for (let m = 1; m <= 12; m++) {
          corpus = (corpus + mSip) * (1 + r);
          invested += mSip;
        }
        mSip *= 1.1; // 10% step-up every year
      }
    }

    this.invested = Math.round(invested);
    this.corpus = Math.round(corpus);
    this.showResult = true;
  }

  scrollToCalculator() {
    document.getElementById('calculator')
      ?.scrollIntoView({ behavior: 'smooth' });
  }

  scrollToForm() {
    document.getElementById('talktotus')
      ?.scrollIntoView({ behavior: 'smooth' });
  }

}
